var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:like"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.31242 4.66663C5.14836 4.66663 2.58325 7.23173 2.58325 10.3958C2.58325 16.125 9.35409 21.3333 12.9999 22.5448C16.6458 21.3333 23.4166 16.125 23.4166 10.3958C23.4166 7.23173 20.8515 4.66663 17.6874 4.66663C15.7499 4.66663 14.0364 5.62861 12.9999 7.101C12.4716 6.3485 11.7698 5.73438 10.9538 5.31063C10.1379 4.88688 9.23184 4.66598 8.31242 4.66663Z",
    stroke: "#404B63",
    strokeWidth: 1.59503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartImg);
export default __webpack_public_path__ + "static/media/heart-img.7fc73f9aa88761496c95795565c96e7d.svg";
export { ForwardRef as ReactComponent };